import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_URL || '/api/v1';

export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Session-only token for auto-enrolled respondents (not persisted)
let sessionOnlyToken: string | null = null;

export function setSessionOnlyToken(token: string | null) {
  sessionOnlyToken = token;
}

export function getStoredAuthToken(): string | null {
  return localStorage.getItem('access_token') || sessionOnlyToken;
}

// Add auth token to requests
apiClient.interceptors.request.use(
  (config) => {
    const token = getStoredAuthToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Handle auth errors
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Clear tokens and redirect to login
      localStorage.removeItem('access_token');
      localStorage.removeItem('session_token');
      window.location.href = '/auth/signin';
    }
    return Promise.reject(error);
  }
);